import React from 'react';
import { Reorder, useDragControls, useMotionValue } from 'motion/react';
import { useRaisedShadow } from '../../../../../utils/hooks/useRaisedShadow';
import styles from './Button.module.css';

export default function Button(props) {
    
    const { button, editButton, permissions, profile_theme, handleUpdate } = props;

    const y = useMotionValue(0);
    const boxShadow = useRaisedShadow(y);
    const controls = useDragControls();

    const style = {cursor: permissions.edit_button ? 'pointer' : 'default'};

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        controls.start(e, { snapToCursor: true });
    };


    return (
        <Reorder.Item 
            value={button} 
            dragListener={false} 
            dragControls={controls}
            id={button}
            key={button}
            style={button.icon ? { boxShadow, y, borderRadius: '.7rem', background: `linear-gradient(to right, transparent 8%, ${profile_theme.btn_color} 20%, ${profile_theme.btn_color})`, cursor: style.cursor } : { boxShadow, y, borderRadius: '.7rem', background: profile_theme.btn_color, cursor: style.cursor }} 
            onDragEnd={handleUpdate}
            className={button.active ? styles.button : `${styles.button} ${styles.inactive}`}
            onClick={permissions.edit_button !== false ? e => editButton(e, button) : e => e.preventDefault()}
        >
            <div className={styles.icons}>
                {button.icon && <i className={button.icon} style={{background: profile_theme.icon_color}}></i>}
            </div>
            <div className={styles.links}> 
                <h4 className={styles.linkName} style={{color: profile_theme.btm_text_color}}>{button.label === undefined || button.label === '' ? button.ref === 'phone' ? "Work Phone" : button.ref.charAt(0).toUpperCase() + button.ref.slice(1) : button.label}</h4>
            </div>
            <div className={styles.arrow} style={{ touchAction: 'none' }} onPointerDown={handleDrag} onClick={e => {e.preventDefault(); e.stopPropagation();}}>
                <i className='fa-solid fa-grip-vertical' style={{color: profile_theme.btm_text_color, pointerEvents: 'none'}}></i>
            </div>
        </Reorder.Item>
    )
};